/**
 * @override
 * Override base fragment to include content.json but NOT links.
 * Links are fetched separately via useRichTextLinks hook with error handling.
 * This ensures content always renders even if embedded entries are unpublished.
 */

import gql from 'graphql-tag';

export const BaseRichTextBlockFragment = gql`
  fragment BaseRichTextBlockFragment on RichTextBlock {
    __typename
    sys {
      id
    }
    title
    appearance
    content {
      json
    }
    alignment
    animation
    jumpLink
    jumpLinkMarginTop
    quote
  }
`;
